"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedResponse = void 0;
const actions_1 = require("../actions");
class PaginatedResponse {
    constructor() {
        this.data = [];
        this.count = 0;
    }
}
__decorate([], PaginatedResponse.prototype, "data", void 0);
__decorate([], PaginatedResponse.prototype, "count", void 0);
__decorate([], PaginatedResponse.prototype, "filtered", void 0);
__decorate([], PaginatedResponse.prototype, "page", void 0);
__decorate([], PaginatedResponse.prototype, "pageCount", void 0);
__decorate([], PaginatedResponse.prototype, "searchParams", void 0);
__decorate([], PaginatedResponse.prototype, "sort", void 0);
exports.PaginatedResponse = PaginatedResponse;
//# sourceMappingURL=paginated.response.js.map